import styled from "styled-components";

export default styled.div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
`;
